import API_BASE_URL from '../config/api';

export const fetchDonationsByEmail = async (emailID) => {
  try {
    const res = await fetch(`${API_BASE_URL}/vrv-donations-fetchbydonor`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ emailID }),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return parsed.donations || [];
  } catch (err) {
    console.error("Error fetching donations:", err);
    return [];
  }
};

export const fetchAllDonations = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/vrv-donations-getAll`, { method: 'GET' });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return parsed.data || [];
  } catch (err) {
    console.error("Error fetching all donations:", err);
    return [];
  }
};

export const createDonation = async (donation) => {
  try {
    const res = await fetch(`${API_BASE_URL}/vrv-donations-create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(donation),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return { statusCode: res.status, ...parsed };
  } catch (err) {
    console.error("Error creating donation:", err);
    return { statusCode: 500, message: "Internal Error" };
  }
};

export const donationAction = async (payload) => {
  try {
    const token = localStorage.getItem('vrvToken');
    const res = await fetch(`${API_BASE_URL}/vrv-donations-action`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return { statusCode: res.status, ...parsed };
  } catch (err) {
    console.error("Error performing donation action:", err);
    return { statusCode: 500, message: "Internal Error" };
  }
};

export const fetchAllExpenses = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/vrv-expenses-getAll`, { method: 'GET' });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return parsed.data || [];
  } catch (err) {
    console.error("Error fetching expenses:", err);
    return [];
  }
};

export const createExpense = async (expense) => {
  try {
    const token = localStorage.getItem('vrvToken');
    const res = await fetch(`${API_BASE_URL}/vrv-expenses-create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(expense),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return { statusCode: res.status, ...parsed };
  } catch (err) {
    console.error("Error creating expense:", err);
    return { statusCode: 500, message: "Internal Error" };
  }
};

export const expenseAction = async (payload) => {
  try {
    const token = localStorage.getItem('vrvToken');
    const res = await fetch(`${API_BASE_URL}/vrv-expenses-action`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
    return { statusCode: res.status, ...parsed };
  } catch (err) {
    console.error("Error performing expense action:", err);
    return { statusCode: 500, message: "Internal Error" };
  }
};
